import {getCenter, getHeight, getWidth} from 'ol/extent';

import {Icon,Stroke,Style,Text,Fill,Circle,RegularShape,Circle as CircleStyle} from 'ol/style';
import {Point,LineString} from 'ol/geom';
/**
 * 获取图形的中心点坐标
 * @param {*} geometry 
 * @returns 
 */
export function calculateCenter (geometry) {
    let center, coordinates, minRadius;
    const type = geometry.getType();
    if (type === 'Polygon') {
        let x = 0;
        let y = 0;
        let i = 0;
        coordinates = geometry.getCoordinates()[0].slice(1);
        coordinates.forEach(function (coordinate) {
        x += coordinate[0];
        y += coordinate[1];
        i++;
        });
        center = [x / i, y / i];
    } else if (type === 'LineString') {
        center = geometry.getCoordinateAt(0.5);
        coordinates = geometry.getCoordinates();
    } else {
        center = getCenter(geometry.getExtent());
    }
    let sqDistances;
    if (coordinates) {
        sqDistances = coordinates.map(function (coordinate) {
        const dx = coordinate[0] - center[0];
        const dy = coordinate[1] - center[1];
        return dx * dx + dy * dy;
        });
        minRadius = Math.sqrt(Math.max.apply(Math, sqDistances)) / 3;
    } else {
        minRadius =
        Math.max(
            getWidth(geometry.getExtent()),
            getHeight(geometry.getExtent())
        ) / 3;
    }
    return {
        center: center,
        coordinates: coordinates,
        minRadius: minRadius,
        sqDistances: sqDistances,
    };
}

/**
 * 点P到直线AB的垂足及最短距离
 * @param {*} point 需要计算的点
 * @param {*} point1 线段的第一个点
 * @param {*} point2 线段的第二个点
 * @returns point 投影坐标  dist 点P到投影距离  type 垂足位置，不为0表示垂足在线段外
 */
export function pointToFootDist(point, point1, point2){
    let x0 = point[0], x1 = point1[0], x2 = point2[0]
    let y0 = point[1], y1 = point1[1], y2 = point2[1]

    //线段AB 为一个点
    if(x1 == x2 && y1 == y2) return {
        type: true,
        point: point1,
        dist: 0
    }

    let dx = x2 - x1;
    let dy = y2 - y1;
    //r < 0 点P的垂足在线段AB外，且点P距离线段AB最近的点为A
    //r > 1 点P的垂足在线段AB外，且点P距离线段AB最近的点为B
    //r = 0 点P的垂足和点P距离线段AB最近的点为A
    //r = 1 点P的垂足和点P距离线段AB最近的点为B
    let r = (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);

    let px = x1 + dx * r;
    let py = y1 + dy * r;
    return {
        type: r >= 0 && r <= 1, //true  垂足在线段内   false 垂足在线段外
        point: [px, py], //垂足
        dist: Math.sqrt((x0 - px) * (x0 - px) + (py - y0) * (py - y0)) //点P到垂足距离
    };
}

let baseUrl=window.location.protocol+'//' + window.location.host;
let version=process.env.VUE_APP_VERSION||"0.0.1";

/**
 * 要素的样式
 * @param {*} feature 
 * @returns 
 */
export const renderFeature=(feature)=>{
    const geometry = feature.getGeometry();
    let styles= null;
    // 如果Feature条线段
    if(geometry instanceof LineString){
        let text=feature.get("id");
        text="["+text+"]";
        styles = [
            // linestring
            new Style({
                stroke: new Stroke({
                    color: '#ffcc33',
                    width: 3,
                }),
                text:new Text({
                    font:'15px "Fira Sans", sans-serif',
                    text:text,
                    offsetY:-15,
                    placement:"line",
                    fill:new Fill({
                        color:"red"
                    })
                }),
                zIndex:1
            }),
        ];

        geometry.forEachSegment(function (start, end) {
            const dx = end[0] - start[0];
            const dy = end[1] - start[1];
            const rotation = Math.atan2(dy, dx);
            let center=[(start[0]+end[0])/2,(start[1]+end[1])/2];
            // arrows
            styles.push(
                new Style({
                    geometry: new Point(center),
                    image: new Icon({
                        src:  baseUrl + '/img/simulation/arrow.png',
                        anchor: [0.75, 0.5],
                        rotateWithView: true,
                        rotation: -rotation,
                        scale:0.5
                    }),
                    zIndex:1
                })
            );
        });
    }else{
        let nodeProps=feature.getProperties();
        let img=nodeProps.img; // 图片
        let id=nodeProps.id; // id号

        if(img&&(id||id===0)){
            let text="("+nodeProps.id+")";
            // 旋转角度
            let rotation=nodeProps.rotation;
            if(!rotation){
                rotation=0;
            }
            styles = [
                new Style({
                    image: new Icon({
                        src: baseUrl+'/img/simulation/'+nodeProps.img+'?_v'+version,
                        scale:0.7,
                        rotation:rotation,
                    }),
                    stroke: new Stroke({
                        color: 'red',
                        width: 2,
                    }),
                    text:new Text({
                        font:'15px "Fira Sans", sans-serif',
                        text:text,
                        offsetY:-35,
                        fill:new Fill({
                            color:"red"
                        })
                    }),
                    zIndex:1000
                }),
            ];
        }else{
            styles=new Style({
                image: new Circle({
                    // 点的颜色
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.7)'
                    }),
                    stroke:new Stroke({
                        color:"rgba(109, 196, 230, 1)"
                    }),
                    // 圆形半径
                    radius: 5
                }),
                stroke: new Stroke({
                    color: 'rgba(109, 196, 230, 1)',
                    width: 2,
                }),
                fill:new Fill({
                    color:"rgba(255, 255, 255, 0.7)"
                }),
            })
        }
    }
    // 设置要素样式
    feature.setStyle(styles);
    return styles;
}
/** 
 * 元素剪切时的样式 
 * 
*/
export const renderCutFeature=(feature)=>{
    let geom=feature.getGeometry();
    let styles = null;
    // 如果选中的是条线段
    if(geom instanceof LineString){
        let text=feature.get("id");
        text="["+text+"]";
        styles = [
            new Style({
                stroke: new Stroke({
                    color: 'rgba(255,0,0,0.5)',
                    width: 3,
                }),
                text:new Text({
                    font:'15px "Fira Sans", sans-serif',
                    text:text,
                    offsetY:-15,
                    placement:"line",
                    fill:new Fill({
                        color:"rgba(255,0,0,0.5)"
                    })
                }),
                zIndex:10000
            }),
        ];

        geom.forEachSegment(function (start, end) {
            const dx = end[0] - start[0];
            const dy = end[1] - start[1];
            const rotation = Math.atan2(dy, dx);
            let center=[(start[0]+end[0])/2,(start[1]+end[1])/2];
            // arrows
            styles.push(
                new Style({
                    geometry: new Point(center),
                    image: new Icon({
                        src:  baseUrl + '/img/simulation/arrow.png',
                        anchor: [0.75, 0.5],
                        rotateWithView: true,
                        rotation: -rotation,
                        scale:0.5
                    }),
                    zIndex:10000
                })
            );

            // 端点
            styles.push(
                new Style({
                    geometry: new Point(start),
                    image: new Circle({
                        fill: new Fill({
                            color: 'rgba(255,0,0,0.5)'
                        }),
                        stroke: new Stroke({
                            color: 'rgba(255,0,0,0.5)',
                            width: 1.25
                        }),
                        radius: 3
                    }),
                    zIndex:10000
                })
            );
            styles.push(
                new Style({
                    geometry: new Point(end),
                    image: new Circle({
                        fill: new Fill({
                            color: 'rgba(255,0,0,0.5)'
                        }),
                        stroke: new Stroke({
                            color: 'rgba(255,0,0,0.5)',
                            width: 1.25
                        }),
                        radius: 3
                    }),
                    zIndex:10000
                })
            );

        });
    }else{
        let nodeProps=feature.getProperties();

        let text="("+nodeProps.id+")";
        // 旋转角度
        let rotation=nodeProps.rotation;
        if(!rotation){
            rotation=0;
        }

        styles = [
            new Style({
                image: new RegularShape({
                    fill: new Fill({
                        color: '#fff'
                    }),
                    stroke: new Stroke({
                        color: 'rgba(255,0,0,0.5)',
                        width: 1,
                    }),
                    points: 4,
                    radius: 30,
                    angle: Math.PI / 4,
                }),
                stroke: new Stroke({
                    color: 'rgba(255,0,0,0.5)',
                    width: 4,
                }),
                zIndex:1
            }),
            new Style({
                image: new Icon({
                    src: baseUrl+'/img/simulation/'+nodeProps.img+'?_v'+version,
                    scale:0.7,
                    rotation:rotation,
                }),
                stroke: new Stroke({
                    color: 'rgba(255,0,0,0.5)',
                    width: 2,
                }),
                text:new Text({
                    font:'15px "Fira Sans", sans-serif',
                    text:text,
                    offsetY:-35,
                    fill:new Fill({
                        color:"rgba(255,0,0,0.5)"
                    })
                }),
                zIndex:1000
            }),
        ];
    }
    feature.setStyle(styles);
    return styles;
}

/**
 * 元素选中时的样式
 * @param {*} feature 
 */
export const renderSelectFeature=(feature)=>{
    let geom=feature.getGeometry();
    let styles=null;
    // 如果选中的是条线段
    if(geom instanceof LineString){
        let text=feature.get("id");
        text="["+text+"]";
        styles = [
            new Style({
                stroke: new Stroke({
                    color: 'red',
                    width: 3,
                }),
                text:new Text({
                    font:'15px "Fira Sans", sans-serif',
                    text:text,
                    offsetY:-15,
                    placement:"line",
                    fill:new Fill({
                        color:"red"
                    })
                }),
                zIndex:10000
            }),
        ];

        geom.forEachSegment(function (start, end) {
            const dx = end[0] - start[0];
            const dy = end[1] - start[1];
            const rotation = Math.atan2(dy, dx);
            let center=[(start[0]+end[0])/2,(start[1]+end[1])/2];
            // arrows
            styles.push(
                new Style({
                    geometry: new Point(center),
                    image: new Icon({
                        src:  baseUrl + '/img/simulation/arrow.png',
                        anchor: [0.75, 0.5],
                        rotateWithView: true,
                        rotation: -rotation,
                        scale:0.5
                    }),
                    zIndex:10000
                })
            );

            // 端点
            styles.push(
                new Style({
                    geometry: new Point(start),
                    image: new CircleStyle({
                        fill: new Fill({
                            color: 'red'
                        }),
                        stroke: new Stroke({
                            color: 'red',
                            width: 1.25
                        }),
                        radius: 3
                    }),
                    zIndex:10000
                })
            );
            styles.push(
                new Style({
                    geometry: new Point(end),
                    image: new CircleStyle({
                        fill: new Fill({
                            color: 'red'
                        }),
                        stroke: new Stroke({
                            color: 'red',
                            width: 1.25
                        }),
                        radius: 3
                    }),
                    zIndex:10000
                })
            );

        });

    }else{
        let nodeProps=feature.getProperties();

        let text="("+nodeProps.id+")";
        // 旋转角度
        let rotation=nodeProps.rotation;
        if(!rotation){
            rotation=0;
        }

        styles = [
            new Style({
                image: new Icon({
                    src: baseUrl+'/img/simulation/red.png',
                    scale:0.9,
                }),
                stroke: new Stroke({
                    color: 'red',
                    width: 2,
                }),
                zIndex:1
            }),
            new Style({
                image: new Icon({
                    src: baseUrl+'/img/simulation/'+nodeProps.img+'?_v'+version,
                    scale:0.7,
                    rotation:rotation,
                }),
                stroke: new Stroke({
                    color: 'red',
                    width: 2,
                }),
                text:new Text({
                    font:'15px "Fira Sans", sans-serif',
                    text:text,
                    offsetY:-35,
                    fill:new Fill({
                        color:"red"
                    })
                }),
                zIndex:1000
            }),
        ];
    }
    // 设置样式
    return styles;
}